export const SAVE_WATCH_EMBEDDED_DATA = 'watch/SAVE_WATCH_EMBEDDED_DATA'
